<div class="ic1-my-16">
  <ng-ui-kit-accordion
    [disabled]="!showStep2"
    [title]="'ACTIVATION_STEPS_PAGE.FIRST_EMIS_STEP.TITLE' | translate"
    [icon]="showCheck ? 'check' : ''"
    [open]="showStep2"
    [step]="!showCheck ? stepNumber : 0">
    <ng-container content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="ic1-col-12" *ngIf="isTrissUser; else notTrissUser">
          <ng-ui-kit-toast
            *ngIf="showInfo"
            status="info"
            [text]="
              'ACTIVATION_STEPS_PAGE.FORCE_PWD_STEP.ACTIVATION_INFO_TRISS'
                | translate
            "
            (click)="showInfo = false">
          </ng-ui-kit-toast>
        </div>
        <ng-template #notTrissUser>
          <ng-ui-kit-toast
            class="ic1-col-12"
            *ngIf="showInfo"
            status="info"
            [text]="
              'ACTIVATION_STEPS_PAGE.FORCE_PWD_STEP.ACTIVATION_INFO' | translate
            "
            (click)="showInfo = false">
          </ng-ui-kit-toast>
        </ng-template>
        <div class="ic1-row">
          <div
            class="ic1-col-12 desc ic1-my-12"
            [HTMLTranslate]="'ACTIVATION_STEPS_PAGE.FIRST_EMIS_STEP.DESC'"></div>

          <!-- <pre>{{ model | json }}</pre> -->
          <formly-form
            [form]="form"
            [fields]="fields"
            [model]="model"
            [options]="formOptions"></formly-form>

          <!-- <div class="ic1-col-12 ic1-col-lg-6">
            <div class="ic1-form-group">
              <app-otp-input formControlName="otp"></app-otp-input>
            </div>
          </div> -->

          <div class="ic1-col-12 buttons-container ic1-mt-16">
            <ng-ui-kit-button
              color="secondary"
              [label]="
                'ACTIVATION_STEPS_PAGE.FIRST_EMIS_STEP.BTN_CANCEL' | translate
              "
              type="button"
              size="sm"
              (onClick)="clearForm()">
            </ng-ui-kit-button>

            <app-submit-button
              type="submit"
              [label]="
                'ACTIVATION_STEPS_PAGE.FIRST_EMIS_STEP.BTN_CONFIRM' | translate
              "
              translate-key="ACTIVATION_STEPS_PAGE.FIRST_EMIS_STEP.BTN_CONFIRM"
              [disabled]="loading">
            </app-submit-button>
          </div>
        </div>
      </form>
    </ng-container>
  </ng-ui-kit-accordion>
</div>
